import React from "react";
import { useEffect } from "react";
import { AuthRestartButton } from "../misc/restart-button.component";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import Show from "../../../utils/show.component";
import { determineCancelDisclosure } from "../misc/disclosures";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";

export const AuthRecurringCancellationReview = (props) => {
  const advance = () => {
    window.scrollTo(0, 0);

    const cancelDetails = {
      AgreementId: props.selectedLoan.RecurringPayment.RecurringPaymentAgreementId,
      EmailOverride: "",
      DeclinedEmailReceipt: false,
    };

    props.callAuthCancelRecurring(cancelDetails);
  };

  useEffect(() => {
    // If the payment response has this property, that means there were no errors
    // submitting the payment and the paymentResponse property has been set
    if (props.paymentResponse.hasOwnProperty("Description")) {
      props.setProcessStep(2);
    }
  }, [props.paymentResponse]);

  return (
    <AuthPaymentContainer title="Cancel AutoPay">
      <div className="text-centered bold f20">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <Show condition={props.selectedLoan.IsOpenEndedLoan === true}>
          <ReviewDisplayField
            title={"Payment Method"}
            value={props.openEndPaymentType}
            valueClassNames={"minwidth-fit"}
            titleColumnSize={"col-md-5"}
            valueColumnSize={"col-md-7"}
          />
        </Show>
        <ReviewDisplayField title={"First Payment Date"} value={props.firstPaymentDate} />
        <ReviewDisplayField
          title={"Payment Frequency"}
          value={props.paymentFrequency}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField
          title={"Payment Day"}
          value={props.paymentDay}
          valueClassNames={"minwidth-fit"}
          titleColumnSize={"col-md-5"}
          valueColumnSize={"col-md-7"}
        />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`Ending in ${props.paymentAccount}`}
          valueClassNames={"minwidth-fit"}
        />
        <Show condition={props.selectedLoan.IsOpenEndedLoan !== true}>
          <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
        </Show>
      </div>
      <div className="f12 italic">
        {determineCancelDisclosure(
          props.paymentFrequency,
          props.paymentDay,
          props.paymentAccount,
          props.paymentAmount,
          props.openEndPaymentType,
          props.selectedLoan.IsOpenEndedLoan,
          props.isInternalTransfer
        )}
      </div>
      <AuthContinue type="button" title="Cancel AutoPay" onClickFunction={() => advance()} />
      <AuthRestartButton backToLoans={props.backToLoans} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/review/auth-recurring-cancellation-review.component.js